import { http } from "./http";
import type { ApiResponse, User } from "../types/api";

// 📌 GET /users
export const listUsers = async (): Promise<User[]> => {
  const { data } = await http.get<ApiResponse<User[]>>("/users");
  if (!data.success || !data.data) throw new Error(data.error || "Load users failed");
  return data.data;
};

// 📌 GET /users/:id
export const getUser = async (id: number): Promise<User> => {
  const { data } = await http.get<ApiResponse<User>>(`/users/${id}`);
  if (!data.success || !data.data) throw new Error(data.error || "Load user failed");
  return data.data;
};

// 📌 POST /users
export const createUser = async (payload: Partial<User>): Promise<User> => {
  const { data } = await http.post<ApiResponse<User>>("/users", payload);
  if (!data.success || !data.data) throw new Error(data.error || "Create user failed");
  return data.data;
};

// 📌 PUT /users/:id
export const updateUser = async (id: number, payload: Partial<User>): Promise<User> => {
  const { data } = await http.put<ApiResponse<User>>(`/users/${id}`, payload);
  if (!data.success || !data.data) throw new Error(data.error || "Update user failed");
  return data.data;
};

// 📌 DELETE /users/:id
export const deleteUser = async (id: number): Promise<void> => {
  const { data } = await http.delete<ApiResponse<null>>(`/users/${id}`);
  if (!data.success) throw new Error(data.error || "Delete user failed");
};
